export default (url: string) => {
    return url.split('/')[6];
}